import { Job } from '@core/app/types/logworkApiType'

import { LogWorkTabType } from '@page/logwork/types/types'

/**
 * Get conditions array based on tab type
 */
export const getConditionsByTabType = (tabType: LogWorkTabType): (keyof Job['settings'])[] => {
    switch (tabType) {
        case 'hours':
            return ['logHours']
        case 'manualHours':
            return ['logManualHours']
        case 'piecework':
            return ['logPiecework']
        case 'addition':
            return ['logAddition']
        default:
            return []
    }
}

/**
 * Filter jobs by conditions
 */
export const filterJobsByConditions = (jobs: Job[], conditions: (keyof Job['settings'])[]): Job[] => {
    return jobs.filter((job) => conditions.some((condition) => job.settings[condition]))
}
